export var getProductManager = function getProductManager(_ref) {
  var entity = _ref.entity;
  if (entity.managementCompany && entity.managementCompany) {
    return entity.managementCompany.organization;
  }
  return null;
};